import { render, staticRenderFns } from "./Qyzz.vue?vue&type=template&id=5064da20&scoped=true&"
import script from "./Qyzz.vue?vue&type=script&lang=js&"
export * from "./Qyzz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5064da20",
  null
  
)

export default component.exports